import type {CanvasFollowUpOrigin} from '@shared/canvasFollowUp';
import type {CanvasChatMessage} from './canvas-types';
export interface CanvasFollowUp {
 label:string;action:'angles'|'brief'|'script'|'report'|'images'|'plan';
 id?:number;title?:string;content?:string;imageIds?:string[];value?:string;origin?:CanvasFollowUpOrigin;
}
/** Actions belong to this response's saved artifacts, never a global last-run menu. */
export function canvasFollowUps(message:CanvasChatMessage,images:Array<{id:string;src:string;workflowRunId?:number|null}>,request:string,projectId?:number|null):CanvasFollowUp[]{
 if(message.role!=='assistant'||message.isStreaming||message.playbookJobs?.some(job=>job.status==='queued'||job.status==='running')||(message.playbookProgress&&!message.playbookProgress.isDone))return [];
 const actions:CanvasFollowUp[]=[];
 const set=message.angleSetCard;
 if(set)actions.push({label:isIncompleteConceptSet(message)?'Review saved concepts':'Review & build these concepts',action:'angles',id:set.setId,title:set.title});
 const brief=message.playbookProgress?.campaignBrief;
 if(brief)actions.push({label:'Review campaign brief',action:'brief',title:brief.title,content:brief.content});
 if(message.videoScriptCard)actions.push({label:'Review & build this video',action:'script',id:message.videoScriptCard.draftId,title:message.videoScriptCard.title});
 if(message.webResearchReport)actions.push({label:'Review research findings',action:'report',title:'Research findings',content:message.webResearchReport});
 else if(message.sidebarDoc)actions.push({label:'Open this write-up',action:'report',title:message.sidebarDoc.title,content:message.sidebarDoc.content});
 return actions.slice(0,3);
}
export function isIncompleteConceptSet(message:CanvasChatMessage):boolean {
 if (!message.angleSetCard) return false;
 const run=message.conceptsRun;
 return !!run && (run.status==='failed' || run.status==='interrupted' || (typeof message.angleSetCard.angleCount==='number' && message.angleSetCard.angleCount<run.count));
}

export function visibleConceptSuggestions(message:CanvasChatMessage):CanvasChatMessage['suggestionPills'] {
 const choices=message.suggestionPills;
 if(!choices || !isIncompleteConceptSet(message)) return choices;
 const pills=choices.pills.filter(pill=>!/^make these ads\b|^build (?:campaign|these|all)\b/i.test(pill.label) && pill.forcedTool?.name!=='run_angles_to_campaign');
 return pills.length?{...choices,pills}:undefined;
}
